import { InventoryItemOutcome } from "@redotech/crdb-enums/inventory/inventory-item-outcome";
import { SortDestinationColorSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-disposition";
import { inventoryRuleConditionNodeSchema } from "@redotech/redo-inventory-common/inventory-rules/conditions";
import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { sortDestinationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const sortDestinationGuidanceSchema = z.object({
  id: sortDestinationIdFormat.schema,
  name: z.string(),
  color: SortDestinationColorSchema,
});

export const getTransferGuidance = {
  name: "getTransferGuidance" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    debug: z.boolean().optional(),
  }),
  output: z.object({
    guidance: z
      .object({
        disposition: SortDispositionSchema.nullable(),
        color: SortDestinationColorSchema.nullable(),
        merchantName: z.string().nullable(),
        destination: sortDestinationGuidanceSchema.nullable().optional(),
        outcome: z.nativeEnum(InventoryItemOutcome).nullable().optional(),
      })
      .nullable(),
    currentLocation: z.object({ name: z.string() }).nullable(),
    /** The warehouse still owes work on this unit; it routes to Needs Work. */
    workRequested: z.boolean(),
    missed: z
      .array(
        z.object({
          id: sortDestinationIdFormat.schema,
          name: z.string(),
          failedCondition: inventoryRuleConditionNodeSchema,
        }),
      )
      .optional(),
  }),
};

export type GetTransferGuidanceInput = z.infer<
  typeof getTransferGuidance.input
>;
export type GetTransferGuidanceOutput = z.infer<
  typeof getTransferGuidance.output
>;
